import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'
import { campaignSearchSchema } from '@/shared/analytics/campaign-search'
import GtmLandingPage from '@/pages/gtm-landing'
import { buildHead } from '@/shared/seo/seo-config'

const searchSchema = campaignSearchSchema.extend({
  // Legacy: runs used to be shown on the landing itself.
  run: z.string().uuid().optional().catch(undefined),
})

export const Route = createFileRoute('/$lang/')({
  validateSearch: (search) => searchSchema.parse(search),
  // Older links kept the run on the landing (`/?run=<id>`); it has its page now.
  beforeLoad: ({ search, params }) => {
    if (search.run) {
      throw redirect({
        to: '/$lang/gtm/$runId',
        params: { lang: params.lang, runId: search.run },
        search: { checkout: undefined },
        replace: true,
      })
    }
    if (params.lang === 'en') {
      throw redirect({ to: '/', search, replace: true })
    }
  },
  head: ({ params }) => buildHead('landing', params.lang),
  component: GtmLandingPage,
  staticData: { layout: 'public' },
})
